import { render, staticRenderFns } from "./DeliveryCalendar.vue?vue&type=template&id=287b5f68&scoped=true"
import script from "./DeliveryCalendar.vue?vue&type=script&lang=js"
export * from "./DeliveryCalendar.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCalendar.vue?vue&type=style&index=0&id=287b5f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b5f68",
  null
  
)

export default component.exports